import { StageEntityId as t } from "@perxis-auto/trade-in-sdk/types";
const r = t;
export {
  r as APP_ROUTES
};
